import {createFileRoute} from '@tanstack/react-router';

import PatientInteractionsList from '@/practitioner/views/patientInteraction/PatientInteractionsList';

export const Route = createFileRoute('/(practitioner)/patients/$patientId/patient-interactions')({
  component: PatientInteractionsList,
  loader: ({params}) => ({
    patientId: params.patientId
  })
});
